(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blogs-filters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const blogData = JSON.parse(document.getElementById('articles-data').textContent);
  
  let currentBlog = 'videos';
  let currentTag = 'Javelins';
  let currentSort = 'newest';
  let displayedCount = 3;

  const articlesContainer = document.getElementById('articles-container');
  const headingEl = document.getElementById('articles-heading');
  const loadMoreBtn = document.getElementById('load-more');
  const blogButtons = document.querySelectorAll('.blog-tabs button');
  const tagButtons = document.querySelectorAll('.tag-filters button');
  const sortSelect = document.getElementById('sort-select');

  // Helper function to safely parse dates
  function parseDate(dateString) {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? new Date(0) : date;
  }

  // Helper function to get filtered and sorted articles
  function getProcessedArticles() {
    let articles = [...(blogData[currentBlog] || [])];

    // Filter by tag if selected
    if (currentTag && currentTag !== '') {
      articles = articles.filter(article => {
        return article.tags && article.tags.some(tag => 
          tag.toLowerCase().includes(currentTag.toLowerCase())
        );
      });
    }

    // Sort articles
    articles.sort((a, b) => {
      const dateA = parseDate(a.published_at);
      const dateB = parseDate(b.published_at);
      
      if (currentSort === 'newest') {
        return dateB.getTime() - dateA.getTime();
      } else {
        return dateA.getTime() - dateB.getTime();
      }
    });

    return articles;
  }

  function renderArticles() {
    const articles = getProcessedArticles();

    // Update heading
    if (currentTag && currentTag !== '') {
      headingEl.textContent = `All About ${currentTag}`;
    } else {
      headingEl.textContent = `All ${currentBlog.charAt(0).toUpperCase() + currentBlog.slice(1)} Articles`;
    }

    // Clear previous results
    articlesContainer.innerHTML = '';

    // Show articles up to displayedCount
    const articlesToShow = articles.slice(0, displayedCount);
    
    if (articlesToShow.length === 0) {
      articlesContainer.innerHTML = '<p class="col-span-full text-center text-gray-500">No articles found.</p>';
      loadMoreBtn.style.display = 'none';
      return;
    }

    articlesToShow.forEach(article => {
      const articleDiv = document.createElement('div');
      articleDiv.className = 'article-block p-4 border rounded shadow-sm hover:shadow-md transition-shadow';
      
      const publishedDate = parseDate(article.published_at);
      const formattedDate = publishedDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      articleDiv.innerHTML = `
        <a href="${article.url}" class="block hover:opacity-90 transition-opacity">
        <div class="blog_image" style="aspect-ratio: 1 / 1; overflow: hidden; width: 100%; border: 4px solid green;">
  <img src="${article.image}" alt="${article.title}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 0.375rem; margin-bottom: 0.75rem;">
</div>

           ${article.video ? `

           <div class="vide_cus_icon">
      <img 
        src="/cdn/shop/files/Group_987993.png?v=1754395692" 
        alt="Video Icon" 
        class="w-5 h-5 inline-block mb-2 ml-1" />
        </div>
    ` : ''}


          <h3 class="text-lg font-semibold mb-2 hover:text-blue-600 transition-colors">${article.title}</h3>
        </a>
        <div class="flex items-center text-sm text-gray-600">
    <img src="https://cdn.shopify.com/s/files/1/0747/7097/2927/files/Untitled_design_3_e598da23-68ee-4a52-9aef-8b74a2b61927.png?v=1767640286" 
     alt="Author" 
     class="w-6 h-6 rounded-full mr-2">

     <span>By 4Throws</span>
        </div>
      `;
      articlesContainer.appendChild(articleDiv);
    });

    // Show/hide Load More button
    loadMoreBtn.style.display = (displayedCount < articles.length) ? 'block' : 'none';
  }

// Update blog button styles
function updateBlogButtonStyles() {
  blogButtons.forEach(btn => {
    // Remove 'active' from all
    btn.classList.remove('active');

    // Add 'active' to the one that matches currentBlog
    if (btn.getAttribute('data-blog') === currentBlog) {
      btn.classList.add('active');
    }
  });

  // Don't call updateTagStyles() here if the tag filter stays the same
}

// Update tag button styles
function updateTagStyles() {
  tagButtons.forEach(btn => {
    // Remove 'active-tag' from all
    btn.classList.remove('active-tag');
  });

  // Add 'active-tag' to the one that matches currentTag
  const activeTag = document.querySelector(`.tag-btn[data-tag="${currentTag}"]`);
  if (activeTag) {
    activeTag.classList.add('active-tag');
  }
}


  // Initialize sort dropdown
  function updateSortDropdown() {
    sortSelect.value = currentSort;
  }

  // Event listeners
  blogButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const selected = btn.getAttribute('data-blog');
      if (selected === currentBlog) return;
      
      currentBlog = selected;
      currentTag = '';
      displayedCount = 3;
      
      updateBlogButtonStyles();
      updateTagStyles();
      renderArticles();
    });
  });

  tagButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      currentTag = btn.getAttribute('data-tag') || '';
      displayedCount = 3;
      updateTagStyles();
      renderArticles();
    });
  });

  // Sort dropdown event listener
  sortSelect.addEventListener('change', function() {
    currentSort = this.value;
    renderArticles();
  });

  // Load more button
  loadMoreBtn.addEventListener('click', () => {
    displayedCount += 3;
    renderArticles();
  });

  // Initial setup
  updateBlogButtonStyles();
  updateTagStyles();
  updateSortDropdown();
  renderArticles();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.lastScrollTop = 0;
      this.headerHeight = 0;
      this.ticking = false;
      this.scrollDelta = 6;
      this.isFixed = false;
    }

    connectedCallback() {
      this.section = this.closest('.section-header') || document.querySelector('.section-header');
      this.wrapper = this;
      this.header = this.querySelector('.header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);

      this.setHeaderHeight();
      this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      this.handleScroll(true);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    setHeaderHeight() {
      this.headerHeight = this.wrapper.offsetHeight || (this.header ? this.header.offsetHeight : 0) || 72;

      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);

      if (this.section) {
        this.section.style.setProperty('--header-height', `${this.headerHeight}px`);
        this.section.style.minHeight = `${this.headerHeight}px`;
      }
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;

      requestAnimationFrame(() => {
        this.handleScroll(false);
        this.ticking = false;
      });
    }

    handleScroll(force) {
      if (!this.wrapper) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const diff = scrollTop - this.lastScrollTop;
      const revealPoint = this.headerHeight + 24;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.lastScrollTop = scrollTop;
        return;
      }

      if (this.stickyType === 'none') {
        this.reset();
        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        return;
      }

      if (!force && Math.abs(diff) < this.scrollDelta && scrollTop > revealPoint) {
        return;
      }

      
      if (scrollTop <= 2) {
        this.reset();
        this.lastScrollTop = 0;
        return;
      }

      if (this.section) {
        this.section.classList.add('scrolled-past-header');
      }

     
      if (diff > 0) {
        if (this.isFixed) {
          this.hide();
        }
      }

      
      if (diff < 0 && scrollTop > revealPoint) {
        this.reveal();
      }

      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
    setFixed(startHidden = false) {
      if (this.isFixed) return;

      this.wrapper.classList.remove('header-scroll-visible', 'header-scroll-animated');

      if (startHidden) {
        this.wrapper.classList.add('header-scroll-hidden');
      }

      this.wrapper.classList.add('header-scroll-fixed');

      
      this.wrapper.getBoundingClientRect();

      this.isFixed = true;
    }

    hide() {
      if (this.stickyType === 'none') return;

      if (!this.isFixed) return;

      this.wrapper.classList.add('header-scroll-animated', 'header-scroll-hidden');
      this.wrapper.classList.remove('header-scroll-visible');

      if (this.section) {
        this.section.classList.add('scrolled-past-header');
        this.section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      }

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.stickyType === 'none') return;

      const wasFixed = this.isFixed;

      if (!wasFixed) {
        
        this.setFixed(true);

        requestAnimationFrame(() => {
          this.wrapper.classList.add('header-scroll-animated');
          this.wrapper.getBoundingClientRect();

          requestAnimationFrame(() => {
            this.wrapper.classList.add('header-scroll-visible');
            this.wrapper.classList.remove('header-scroll-hidden');
          });
        });
      } else {
        this.wrapper.classList.add('header-scroll-animated', 'header-scroll-visible');
        this.wrapper.classList.remove('header-scroll-hidden');
      }

      if (this.section) {
        this.section.classList.add('scrolled-past-header');
        this.section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      }
    }

    reset() {
      this.wrapper.classList.remove(
        'header-scroll-hidden',
        'header-scroll-visible',
        'header-scroll-fixed',
        'header-scroll-animated'
      );

      this.isFixed = false;

      if (this.section) {
        this.section.classList.remove(
          'scrolled-past-header',
          'shopify-section-header-sticky',
          'shopify-section-header-hidden',
          'animate'
        );
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooltip-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  class TooltipSlider {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.tooltip-slider__slide');
      this.dots = container.querySelectorAll('.tooltip-slider__dot');
      this.prevButton = container.querySelector('.nav-button.prev');
      this.nextButton = container.querySelector('.nav-button.next');
      this.currentSlide = 0;
      this.activeTooltip = null;
      
      if (this.slides.length > 0) {
        this.init();
      }
    }
    
    init() {
      this.bindEvents();
      this.positionTooltips();
      window.addEventListener('resize', () => this.updateActiveConnectorLine());
    }
    
    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.navigate('prev'));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.navigate('next'));
      }
      
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });
      
      // Enable swipe on mobile
      this.enableTouchSwipe();
      
      this.container.querySelectorAll('.plus-icon').forEach(button => {
        button.addEventListener('click', (e) => this.toggleTooltip(e));
      });
    }

    enableTouchSwipe() {
      let touchStartX = 0;
      let touchEndX = 0;
      
      this.container.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, false);
      
      this.container.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      }, false);
      
      this.handleSwipe = () => {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            this.navigate('next');
          } else {
            this.navigate('prev');
          }
        }
      };
    }

    goToSlide(index) {
      if (index === this.currentSlide) return;
      
      // Close any open tooltip
      if (this.activeTooltip) {
        this.activeTooltip.querySelector('.tooltip-content').classList.remove('active');
        this.activeTooltip.querySelector('.connector-line').classList.remove('active');
        this.activeTooltip.querySelector('.plus-icon').classList.remove('active');
        this.activeTooltip = null;
      }
      
      // Update slides
      this.slides[this.currentSlide].classList.remove('active');
      this.dots[this.currentSlide].classList.remove('active');
      
      this.currentSlide = index;
      
      this.slides[this.currentSlide].classList.add('active');
      this.dots[this.currentSlide].classList.add('active');
    }
    
    navigate(direction) {
      const newIndex = direction === 'next' 
        ? (this.currentSlide + 1) % this.slides.length
        : (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      
      this.goToSlide(newIndex);
    }

    toggleTooltip(e) {
      const trigger = e.target.closest('.tooltip-trigger');
      const content = trigger.querySelector('.tooltip-content');
      const line = trigger.querySelector('.connector-line');
      const icon = trigger.querySelector('.plus-icon');
      
      // Close active tooltip if clicking a different one
      if (this.activeTooltip && this.activeTooltip !== trigger) {
        this.activeTooltip.querySelector('.tooltip-content').classList.remove('active');
        this.activeTooltip.querySelector('.connector-line').classList.remove('active');
        this.activeTooltip.querySelector('.plus-icon').classList.remove('active');
      }
      
      // Toggle current tooltip
      const isActive = content.classList.contains('active');
      content.classList.toggle('active');
      line.classList.toggle('active');
      icon.classList.toggle('active');
      
      this.activeTooltip = !isActive ? trigger : null;
      
      // Update connector line position
      if (!isActive) {
        this.updateConnectorLine(trigger);
      }
    }
    
    updateConnectorLine(trigger) {
      const line = trigger.querySelector('.connector-line');
      const content = trigger.querySelector('.tooltip-content');
      const icon = trigger.querySelector('.plus-icon');
      
      // Calculate positions
      const iconRect = icon.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      const triggerRect = trigger.getBoundingClientRect();
      
      // Calculate line coordinates
      const startX = iconRect.width / 2;
      const startY = iconRect.height / 2;
      const endX = contentRect.left - triggerRect.left;
      const endY = contentRect.top - triggerRect.top + contentRect.height / 2;
      
      // Update SVG viewBox and line coordinates
      const width = Math.max(endX + 20, 100);
      const height = Math.max(Math.abs(endY) + 20, 100);
      
      line.setAttribute('width', width);
      line.setAttribute('height', height);
      line.setAttribute('viewBox', `0 0 ${width} ${height}`);
      
      const svgLine = line.querySelector('line');
      svgLine.setAttribute('x1', startX);
      svgLine.setAttribute('y1', startY);
      svgLine.setAttribute('x2', endX);
      svgLine.setAttribute('y2', endY);
      
      const circle = line.querySelector('circle');
      circle.setAttribute('cx', endX);
      circle.setAttribute('cy', endY);
    }
    
    updateActiveConnectorLine() {
      if (this.activeTooltip) {
        this.updateConnectorLine(this.activeTooltip);
      }
    }
    
    positionTooltips() {
      // const tooltipPositions = [
      //   { top: '20%', left: '30%' },
      //   { top: '40%', left: '25%' },
      //   { top: '60%', left: '35%' },
      //   { top: '80%', left: '30%' }
      // ];
       const tooltipPositions = [
        { top: '24rem' },
        { top: '36rem' },
        { top: '48rem' },
        { top: '61rem' }
      ];
      
      this.slides.forEach(slide => {
        const tooltips = slide.querySelectorAll('.tooltip-trigger');
        tooltips.forEach((tooltip, index) => {
          if (tooltipPositions[index]) {
            tooltip.style.top = tooltipPositions[index].top;
            tooltip.style.left = tooltipPositions[index].left;
          }
        });
      });
    }
  }

  const sliders = document.querySelectorAll('.tooltip-slider');
  sliders.forEach(slider => new TooltipSlider(slider));
});

  } catch(e) { console.error(e); }
})();
})();
